import { createBrowserRouter, RouterProvider } from 'react-router';

import { AppShell } from './components/AppShell';
import { RequireAuth } from './features/auth/RequireAuth';
import { CollectionPage } from './pages/CollectionPage';
import { DashboardPage } from './pages/DashboardPage';
import { DesignPage } from './pages/DesignPage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SeriesDetailPage } from './pages/SeriesDetailPage';
import { SeriesListPage } from './pages/SeriesListPage';
import { SettingsPage } from './pages/SettingsPage';
import { WishlistPage } from './pages/WishlistPage';

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      // Working page for the visual language, deliberately not in the navigation.
      { path: 'design', element: <DesignPage /> },
      { path: 'collection', element: <CollectionPage /> },
      { path: 'series', element: <SeriesListPage /> },
      { path: 'series/:id', element: <SeriesDetailPage /> },
      { path: 'wishlist', element: <WishlistPage /> },
      { path: 'settings', element: <SettingsPage /> },
      // The scanner pulls in the zxing decoder; load it only when scanning.
      {
        path: 'scan',
        lazy: async () => ({ Component: (await import('./pages/ScanPage')).ScanPage }),
      },
      {
        path: 'scan/queue',
        lazy: async () => ({ Component: (await import('./pages/ScanQueuePage')).ScanQueuePage }),
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);

export function App() {
  return <RouterProvider router={router} />;
}
